import React from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useApiMutation } from "src/hooks/useApiMutation";

interface Props {
	open: boolean;
	handleClose: () => void;
	visitorId: number | null;
	visitorName?: string;
}

const DeleteVisitor: React.FC<Props> = ({
	open,
	handleClose,
	visitorId,
	visitorName,
}) => {
	const { mutate: deleteVisitor, isPending } = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/v1/admin/visitor/${visitorId}`,
		invalidateQueries: ["Visitors"],
	});

	const handleDelete = () => {
		if (!visitorId) return;
		deleteVisitor(undefined as any, {
			onSuccess: () => {
				handleClose();
			},
		});
	};

	return (
		<Dialog
			open={open}
			onClose={isPending ? undefined : handleClose}
			disableEnforceFocus
			maxWidth="xs"
			fullWidth
		>
			<DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
				Delete Visitor
			</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ textAlign: "center", color: "text.secondary" }}>
					Are you sure you want to delete{" "}
					<strong>{visitorName || `Visitor #${visitorId}`}</strong>?
					This action cannot be undone.
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "center", pb: 2 }}>
				<Button
					onClick={handleClose}
					variant="outlined"
					disabled={isPending}
					sx={{
						borderColor: "grey.400",
						color: "grey.700",
						"&:hover": { backgroundColor: "grey.100" },
					}}
				>
					Cancel
				</Button>
				<LoadingButton
					onClick={handleDelete}
					color="error"
					variant="contained"
					loading={isPending}
				>
					<span>Delete</span>
				</LoadingButton>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteVisitor;
